// extracted by mini-css-extract-plugin
module.exports = {"feed-container":"card-middle_feed-container__EdFJh","feed-text":"card-middle_feed-text__Tz5aL"};